<div class="app-table-wrapper">
  <cm-ui-table
    [loading]="(isLoading$ | async) || false"
    [columns]="(columns$ | async) || []"
    [rows]="(rows$ | async) || []"
    [rowsTotal]="(rowCount$ | async) || 0"
    [pageSize]="(pageSize$ | async) || 25"
    [pageIndex]="(pageIndex$ | async) || 0"
    [selectionType]="selectionType"
    (paginateChange)="onPage($event)"
    (sortChange)="onPageSort($event)"
    (selectionChange)="selectionChange.emit($event)">
  </cm-ui-table>
</div>
